import { jsxs as l, jsx as s } from "react/jsx-runtime";
import "react";
import h from "../StarRating/index.js";
const d = _ref => {
    let {
      rating: e,
      date: a,
      className: t,
      children: n,
      ...o
    } = _ref;
    return /* @__PURE__ */l("div", {
      className: `sash-ReviewsCard h-full border border-gray-10 bg-white p-6 shadow-[0_2px_4px_rgba(0,0,0,0.05)] md:px-8 md:py-12 ${t || ""}`,
      ...o,
      children: [a && /* @__PURE__ */s("p", {
        className: "text-caption mb-2.5 md:mb-4",
        children: a
      }), e && /* @__PURE__ */s(h, {
        rating: e,
        className: "mb-6",
        hideRating: !0
      }), n]
    });
  },
  r = _ref2 => {
    let {
      content: e,
      className: a,
      ...t
    } = _ref2;
    return /* @__PURE__ */s("div", {
      className: `sash-ReviewCard-Heading text-h3 mb-3 mt-0 md:mb-4 ${a || ""}`,
      dangerouslySetInnerHTML: {
        __html: e
      },
      ...t
    });
  },
  m = _ref3 => {
    let {
      content: e,
      className: a,
      ...t
    } = _ref3;
    return /* @__PURE__ */s("div", {
      className: `sash-ReviewCard-Content text-body-2 mb-3 mt-0 md:mb-4 ${a || ""}`,
      dangerouslySetInnerHTML: {
        __html: e
      },
      ...t
    });
  },
  i = _ref4 => {
    let {
      name: e,
      className: a,
      ...t
    } = _ref4;
    return /* @__PURE__ */s("div", {
      className: `sash-ReviewCard-Author text-subtitle-2 m-0 ${a || ""}`,
      dangerouslySetInnerHTML: {
        __html: e
      },
      ...t
    });
  };
d.Heading = r;
d.Content = m;
d.Author = i;
r.displayName = "ReviewCard.Heading";
m.displayName = "ReviewCard.Contet";
i.displayName = "ReviewCard.Author";
const v = d;
export { v as default };